export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      5077.913832199546,
    ],
    button_spin: [
      7000,
      1017.3242630385495,
    ],
    end_free_spin: [
      10000,
      3940.136054421769,
    ],
    free_bet_big_win: [
      15000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      18000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      22000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      24000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      27000,
      43321.179138322,
    ],
    free_spin_music: [
      72000,
      45992.92517006802,
    ],
    free_spin_popup: [
      119000,
      4572.879818594103,
    ],
    free_spin_start: [
      125000,
      4012.6984126983984,
    ],
    inside_buttons: [
      131000,
      245.26077097505095,
    ],
    main_ambient: [
      133000,
      98337.95918367349,
    ],
    main_music: [
      233000,
      116037.3696145125,
    ],
    mega_win: [
      351000,
      6192.471655328802,
    ],
    outside_buttons: [
      359000,
      117.55102040814336,
    ],
    reel_stop_01: [
      361000,
      503.5827664399335,
    ],
    reel_stop_02: [
      363000,
      497.77777777779875,
    ],
    reel_stop_03: [
      365000,
      477.46031746032713,
    ],
    reel_stop_04: [
      367000,
      520.9977324262809,
    ],
    reel_stop_05: [
      369000,
      500.6802721088661,
    ],
    reel_stop_06: [
      371000,
      480.3628117913945,
    ],
    regular_win: [
      373000,
      3287.074829931953,
    ],
    scatter_win: [
      378000,
      3870.476190476211,
    ],
    tap_to_play: [
      383000,
      6685.895691609971,
    ],
    ultra_win: [
      391000,
      5475.555555555558,
    ],
    wild_win: [
      398000,
      3644.0816326530694,
    ],
  },
}
